import { render } from "./MyinvFeesBasic.vue?vue&type=template&id=4635ad7d&scoped=true&ts=true"
import script from "./MyinvFeesBasic.vue?vue&type=script&lang=ts"
export * from "./MyinvFeesBasic.vue?vue&type=script&lang=ts"

import "./MyinvFeesBasic.vue?vue&type=style&index=0&id=4635ad7d&scoped=true&lang=scss"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4635ad7d"]])

export default __exports__